<template lang="pug">
  .component-create-plan(v-if="toc !== null")
    .row
      .columns
        label Name
        template(v-if="$route.params.hasOwnProperty('id')" )
          TranslateField(group="entities", :field="toc._translatable.name", label="Name", :value="toc.name", :editable="false")
            input.input-group-field(type="text", v-model="toc.name")
        template(v-else)
          input(type="text", v-model="toc.name")
      .columns
        label Toc Type
          selectize-toc-type(@optionSelected="setTocType", :selectedValue="toc.toc_type.id")
      .columns
        label Version
          input(type="text", v-model="toc.version")

    .row
      .columns
        label Required from
          DatePicker(v-model="toc.required_from", :initialDate="toc.required_from")
      .columns
        label Optional
        input(type="checkbox", v-model="toc.optional")

      .columns
        label Disabled
        input(type="checkbox", v-model="toc.disabled")
    .row
      .columns
        label Acceptance statement
        template(v-if="$route.params.hasOwnProperty('id')" )
          TranslateField(group="entities", :field="toc._translatable.acceptance_statement", label="Acceptance statement" :value="toc.acceptance_statement", :editable="false")
            input.input-group-field(type="text", v-model="toc.acceptance_statement")
        template(v-else)
          input(type="text", v-model="toc.acceptance_statement")
        label External url
          input(type="text", v-model="toc.link")


      .columns
        label Priority
          input(type="text", v-model="toc.priority")

        label Attachment

        KeplerFileUpload(selected-prefix="tocs", selected-visibility="public",  @sel="handleFileSelector", :preview-url="toc.attachment")
        TocAttachmentTranslationReveal.mt-3(v-model="toc.attachment_translations" )

    .row
      .column
    .row.columns
      template(v-if="!$route.params.hasOwnProperty('id')" )
        label Content
      template(v-else)
        TranslateField(group="entities", :field="toc._translatable.content", label="Content", :value="toc.content", :editor="true", :editable="false")
      Editor(v-model="toc.content")
      button.button(@click="createToc") Save

</template>
<script type="text/babel">

import DatePicker from '../../components/structure/DatePicker'
import SelectizeTocType from '../../components/structure/ui/lists/selectize/SelectizeTocType'
import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
import KeplerFileUpload from '../../components/structure/KeplerFileUpload'
import MaggieHelper from '../../maggieHelper'
import Editor from '../../components/structure/ui/Editor'
import TranslateField from "./TranslateField.vue";
import ModalReveal from "../../components/structure/foundation/ModalReveal.vue";
import MdiIcon from "../../components/structure/ui/MdiIcon.vue";
import TocAttachmentTranslationReveal
  from "../../components/structure/ui/actions/reveal/TocAttachmentTranslationReveal.vue";

export default {
  name: 'CreateToc',
  components: {
    TocAttachmentTranslationReveal,
    MdiIcon, ModalReveal, TranslateField, Editor, KeplerFileUpload, SelectizeTocType, DatePicker
  },
  data() {
    return {
      toc: {
        id: null,
        content: '',
        required_from: null,
        link: null,
        attachment: null,
        attachment_translations: {},
        name: null,
        acceptance_statement: null,
        version: null,
        optional: 0,
        priority: 0,
        toc_type: {
          id: 1,
          name: null,
          group: null,
          priority: 0,
          uid: null
        },
        disabled: false,
      }
    }
  },
  computed: {},
  mounted() {
  },
  created() {
    if (this.$route.params.id) {
      this.toc = null
      KeplerBackofficeSdk.tocs.select(this.$route.params.id).get((data) => {
        this.toc = Object.assign({}, data)
        this.toc.toc_type_id = data.toc_type_id
      })
    }
  },
  methods: {
    setTocType(obj) {
      this.toc.toc_type_id = obj.id
    },
    createToc() {
      if (this.$route.params.id) {
        KeplerBackofficeSdk.tocs.select(this.toc.id).edit(this.toc, (data) => {
          MaggieHelper.notification('edited', 'Toc edited successfully')
          this.$router.push({name: 'tocs'})
        })
      } else {
        KeplerBackofficeSdk.tocs.make(this.toc, (data) => {
          MaggieHelper.notification('created', 'Toc created successfully')
          this.$router.push({name: 'tocs'})
        })
      }

    },
    handleFileSelector(path) {
      this.toc.attachment = path
    }
  },
}
</script>
<style lang="sass" rel="stylesheet/sass">
.component-create-plan
  background: white
  padding: 1em 2em

</style>



// WEBPACK FOOTER //
// CreateToc.vue?622869b7